// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('base.vats', {
        url: '/vats?searchTerm',
        views: {
            'baseList': {
            templateUrl: 'main/base/vats/vats.tpl.html',
            controller: 'VatsController as vm'
        }},
        resolve: {
            vats: vatsResolver,
            searchTerm: searchTermesolver
        }
    });
}

// @ngInject
function vatsResolver(VatsApiService, $stateParams) {
    return VatsApiService.getVats({ page: 0, searchTerm:$stateParams.searchTerm, pageSize:null});
}

// @ngInject
function searchTermesolver($stateParams) {
    return $stateParams.searchTerm;
}

// @ngInject
function VatsController($rootScope, $state, $scope, vats, VatsApiService, loadSpinnerService, searchTerm) {
    var vm = this;

    vm.currentUser = $rootScope.currentUser;

    vm.vats = vats;
    vm.selectedVatId = 0;
    vm.searchTerm = (searchTerm) ? searchTerm : '';
    vm.currentPage = 1;

    vm.searchTermChange = searchTermChange;

    activate();

    function activate() {
        $scope.$watch(function() { return $state.params.vatId; }, function(newValue, oldValue) {
            vm.selectedVatId = parseInt($state.params.vatId,10);
        });
        $rootScope.$on('Vat.Inserted', function(event, response) {
        });
        $rootScope.$on('Vat.Updated', function(event, response) {
        });
        $rootScope.$on('Vat.Deleted', function(event, response) {
        });
        $rootScope.$on('Vat.Changed', function(event, response) {
            loadVats();
        });
    }

    function loadVats() {
        loadSpinnerService.start('mainSpinner');
        var request = { page: (vm.currentPage - 1), searchTerm:vm.searchTerm, pageSize:vm.itemsPerPage};
        VatsApiService.getVats(request).then(function(response) {
            vm.vats = response;
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner',{force: true});
        });
    }

    function searchTermChange() {
        vm.currentPage = 1;
        loadVats();
    }

}

angular
    .module('base.vats', ['vats.api','vats.vat'])
    .config(stateConfig)
    .controller('VatsController', VatsController);
